import type { CrmOrganizationListParams } from "../types";

export const crmOrganizationDefaultListParams: CrmOrganizationListParams = {
  page: 1,
  pageSize: 20,
  orgType: "高校",
  sortField: "updated_at",
  sortDirection: "desc",
};

export const crmOrganizationPageSizeOptions = [10, 20, 50, 100];

export const crmOrganizationCollegeType = "高校";

export const crmOrganizationTypeOptions = ["高校", "中小学", "企业", "机构", "其他"];

export const crmOrganizationSubtypeOptions = [
  "本科",
  "高职",
  "985",
  "211",
  "双一流",
  "民办本科",
  "独立学院",
  "其他",
];

export const crmOrganizationSiteTypeOptions = ["校区", "办公点", "园区", "分部", "其他"];
